import { render, staticRenderFns } from "./ModalMostrarProgramaUniversidad.vue?vue&type=template&id=63200f2f"
import script from "./ModalMostrarProgramaUniversidad.vue?vue&type=script&lang=js"
export * from "./ModalMostrarProgramaUniversidad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports